import UploadImage from '@/components/upload-image/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';
import PublishPurchaseService from '../publish-purchase-service';
import Service from '@/service/index.js';

export default {
  components: {
    UploadImage,
    ProcessNavigation
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'],
      step: 6,
      id: '',
      oldId: '',
      tradeType: '',
      isCreated: true,
      projectInfo: {},
      form: {
        files: [],
        qualityStandard: '',
        engineeringSpecifications: '',
        otherRequirements: '',
        timeLimitProject: '',
        constructionSite: '',
        quoteRequests: '',
        projectManagementAgencyRequirements: '',
        businessOtherRequirements: '',
        purchaseProjectSituation: '',
        warrantyPeriodServiceRequirements: ''
      },
      purchaseFileType: [],
      isAgree: '',
      submitStatus: 'init',
      fileType: {
        '1': ['12', '13', '14', '15'],
        '2': ['12'],
        '3': ['12']
      },
      projectTypeOfPur: null,
      rules: {
        purchaseProjectSituation: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        qualityStandard: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        engineeringSpecifications: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        timeLimitProject: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        constructionSite: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        quoteRequests: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        projectManagementAgencyRequirements: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        businessOtherRequirements: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        warrantyPeriodServiceRequirements: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      processList: 'purchaseProcessList'
    })
  },
  async created () {
    window.scrollTo(0, 0);

    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    this.projectTypeOfPur = this.$route.query.projectTypeOfPur;

    let fileList = this.fileType[this.projectTypeOfPur];
    let title = Number(this.projectTypeOfPur) !== 1 ? '采购项目具体内容（或一览表）' : '';
    await Service.getSelectList('PURCHASE_FILE').then(res => {
      if (res && res.code === '0') {
        res.data && res.data.map(item => {
          if(fileList.includes(item.code)) {
            this.form.files.push({
              projectFileType: Number(item.code),
              title: title || item.value,
              filePaths: [],
              defaultImage: [],
              inputValue: '',
              desc: item.description,
              fileLength: null
            });
          }
        });
        // this.purchaseFileType = res.data.sort((a, b) => a.sort - b.sort).splice(10, 14);
        // this.initFiles();
      }
    });
    this.getNewsPurchaseFile();
    // if (this.oldId) {
    //   this.getOldAttachmentInfo().then(() => {}, () => {
    //     if (this.id) {
    //       this.getNewsPurchaseFile();
    //     }
    //   });
    // } else {
    //   this.getNewsPurchaseFile();
    // }
  },
  methods: {
    // 新id获取数据 回显
    getNewsPurchaseFile () {
      let params = {
        purchaseId: this.oldId || this.id,
        echoCode: 'PURCHASE_FILE'
      };
      PublishPurchaseService.getPurchaseInfo(params).then(res => {
        let resData = res && res.data;
        if (resData) {
          this.isCreated = false;
          for (let key in resData) {
            if (this.form.hasOwnProperty(key)) {
              this.form[key] = resData[key];
            }
            if(key === 'listFile' && resData.listFile){
              this.form.files.map(item => {
                const index = resData.listFile.findIndex(file => item.projectFileType === Number(file.type));
                if(index >= 0) {
                  item.inputValue = resData.listFile[index].description;

                  let urls = resData.listFile[index].urls || [];
                  urls.forEach(image => {
                    item.defaultImage.push({
                      url: image.fullPath,
                      ossImgUrl: image.filePath,
                      sourceImgUrl: image.filePath
                    });
                    item.filePaths.push({
                      ossImgUrl: image.fullPath,
                      sourceImgUrl: image.filePath
                    });
                  });
                }
              });
            }
            if (this.oldId && !this.id) {
              // 更新
              this.isCreated = true;
            } else {
              // 保存
              this.isCreated = false;
            }
          }
        }
      });
    },
    // 文件包含内容
    initFiles () {
      this.purchaseFileType.forEach(item => {
        this.form.files.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: [],
          defaultImage: [],
          inputValue: '',
          desc: item.description,
          fileLength: null
        });
      });
    },
    // 文件必填校验
    fileRules (item) {
      if(this.projectTypeOfPur !== 1 && item.projectFileType !== 15) {
        return {
          required: true,
          message: '请输入',
          trigger: 'change'
        };
      }
    },
    // 上传图片
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].fileLength = event.length;
      } else {
        this.form.files[index].fileLength = null;
      }
    },
    // 返回上一步
    previousStep () {
      this.$router.back();
    },
    // 点击下一步
    next() {
      this.$refs['editPurchaseFile'].validate(valid => {
        if (valid) {
          this.isAgree = true;
          const files = [];
          this.form.files.forEach(item => {
            const filePaths = [];
            item.filePaths.forEach(obj => {
              filePaths.push(obj.sourceImgUrl);
            });
            files.push({
              imgEnumType: item.projectFileType,
              urls: [...filePaths],
              description: item.inputValue
            });
          });
          let params = {
            ...this.form,
            files,
            purchaseId: this.id
          };
          if (this.isCreated) {
            this.savePurchaseFile(params);
          } else {
            this.updatePurchaseFile(params);
          }
        } else {
          return false;
        }
      });
    },
    // 保存数据
    savePurchaseFile(params) {
      PublishPurchaseService.saveProjectPurchaseFileInfo(params).then(res => {
        console.log(res.data);
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          this.$router.push('/publish-purchase/success');
        }
      }).catch(error => {
        this.submitStatus = 'failed';
        if (error && error.data && error.data.reason) {
          this.$errorMessage(error.data.reason);
        } else {
          this.$errorMessage('保存项目信息失败');
        }
      });
    },
    // 更新数据
    updatePurchaseFile(params) {
      PublishPurchaseService.updateProjectPurchaseFileInfo(params).then(res => {
        console.log(res.data);
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          this.$router.push('/publish-purchase/success');
        } else if (res && res.reason) {
          this.submitStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.submitStatus = 'failed';
          errorMessage('更新项目信息失败');
        }
      });
    }
  }
};
